import type { ActionsForRole } from "../roleManagment";

export enum AdminSections {
  OVERVIEW = "Overview",
  LEGAL_ENTITIES_LIST = "AccountManagementLegalEntitiesList",
  LEGAL_ENTITY = "AccountManagementLegalEntity",
  GROUPS_LIST = "AccountManagementGroupsList",
  GROUP = "AccountManagementGroup",
  BRANDS_LIST = "AccountManagementBrandsList",
  BRAND = "AccountManagementBrand",
  BRANCHES_LIST = "AccountManagementBranchesList",
  BRANCH = "AccountManagementBranch",
  DINERS_LIST = "DinersList",
  DINER = "Diner",
  DASHBOARDS = "ReportingDashboards",
  TRANSACTIONS_LIST = "ReportingTransactionsList",
  TRANSACTION = "ReportingTransaction",
  TOP_UPS = "ReportingTopUps",
  SETTLEMENTS = "ReportingSettlements",
  CREDIT_BALANCE = "ReportingCreditBalance",
  AUDIT_LOG = "ReportingAuditLog",
  PORTAL_USERS_ROLES_LIST = "WebConfigurationsPortalUsersRolesList",
  PORTAL_USERS_LIST = "WebConfigurationsPortalUsersList",
  PORTAL_USER = "WebConfigurationsPortalUser",
  ADMIN_TEAM_ROLES_LIST = "WebConfigurationsAdminTeamRolesList",
  ADMIN_TEAM = "WebConfigurationsAdminTeam",
  APP_CONTROL = "MobileConfigurationsAppControl",
  TAGS = "MobileConfigurationsTags",
  BUSINESS_RULES = "MobileConfigurationsBusinessRules",
  PROMOTION_ENGINE = "IntegrationsPromotionEngine",
  MARKETING_CAMPAIGNS = "IntegrationsMarketingCampaigns",
  SYSTEM_EMAILS = "IntegrationsSystemEmails",
}

export type AdminPermission = {
  action: ActionsForRole;
  section: AdminSections;
};

export interface ITeamRole {
  id: string;
  name: string;
  assignedUsersCount: number;
  createdAt: string;
  updatedAt: string;
  active: boolean;
  isSystem: boolean;
  permissions: AdminPermission[];
}

export interface ICreateTeamRole {
  name: string;
  permissions: AdminPermission[];
}

export interface IAssignmentsUserToTeamRole {
  adminIds: string[];
}

export interface ITeamRoleAssignmentsResponse {
  assignedCount: number;
  assignedAdminIds: string[];
  skippedCount: number;
  skippedAdminIds: string[];
}
